import React from "react";

export default function SideProductSalesCopy(props) {
  // PROPS COMING FROM SideProductModalContent
  const { product, width } = props;

  return (
    <>
      <div className={width < 800 ? "col w90p" : "col w90p"}>
        <div className="marupside2">
          <h1 className="fs2 bold-font txtcenter marupside1 lh3-5">
            {product.sideProductsHeadline}
          </h1>
        </div>
        {product.sideProductsImage && (
          <img
            className="w100p shadow-all marb2"
            src={product.sideProductsImage}
            alt="beddo™"
          />
        )}
        <h2 className="fs1-75 marb2 lh2-5">{product.sideProductsSubline}</h2>
      </div>
      <div className={width < 800 ? "col w90p" : "col w90p"}>
        {product.sideProductsBulletOne && (
          <div className="marupside2">
            <hr />
            <h1 className="fs2 bold-font txtcenter marupside1 lh3-5">
              Her Bir Set Ürünü Bakın Size Ne Yararlar Sağlıyor
            </h1>
            <hr />
          </div>
        )}
      </div>
      {product.sideProductsBulletOne && (
        <ul
          className={
            width < 800 ? "fs1-3 w90p margintop-1" : "fs1-6 w90p margintop-1"
          }
        >
          {product.sideProductsBulletOne && (
            <li className="marb2 padb-1 beddo-border-bottom-light lh2-5">
              <i className="far fa-check green fs16"></i>{" "}
              {product.sideProductsBulletOne}
            </li>
          )}
          {product.sideProductsBulletTwo && (
            <li className="marb2 padb-1 beddo-border-bottom-light lh2-5">
              <i className="far fa-check green fs16"></i>{" "}
              {product.sideProductsBulletTwo}
            </li>
          )}
          {product.sideProductsBulletThree && (
            <li className="marb2 padb-1 beddo-border-bottom-light lh2-5">
              <i className="far fa-check green fs16"></i>{" "}
              {product.sideProductsBulletThree}
            </li>
          )}
          {product.sideProductsBulletFour && (
            <li className="marb2 padb-1 beddo-border-bottom-light lh2-5">
              <i className="far fa-check green fs16"></i>{" "}
              {product.sideProductsBulletFour}
            </li>
          )}
          {product.sideProductsBulletFive && (
            <li className="marb2 padb-1 beddo-border-bottom-light lh2-5">
              <i className="far fa-check green fs16"></i>{" "}
              {product.sideProductsBulletFive}
            </li>
          )}
        </ul>
      )}
    </>
  );
}
